// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
let ConversationPageSelectedConversationDisplayer = require("./ConversationPageSelectedConversationDisplayer.bs.js");
let ConversationPageExistingConversationQuery_graphql = require("../../../__generated__/ConversationPageExistingConversationQuery_graphql.bs.js");
let ConversationPageExistingConversation_conversation_graphql = require("../../../__generated__/ConversationPageExistingConversation_conversation_graphql.bs.js");

let convertVariables = ConversationPageExistingConversationQuery_graphql.Internal.convertVariables;

let convertResponse = ConversationPageExistingConversationQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ConversationPageExistingConversationQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ConversationPageExistingConversationQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationPageExistingConversationQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ConversationPageExistingConversationQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(ConversationPageExistingConversationQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ConversationPageExistingConversationQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ConversationPageExistingConversationQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertFragment = ConversationPageExistingConversation_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageExistingConversation_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageExistingConversation_conversation_graphql.node, convertFragment, fRef);
}

let ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageExistingConversation$RecordPageView(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationPageExistingConversation_conversation_graphql.node, convertFragment, props.conversation);
  let match = conversation.conversationContext;
  if (match === undefined) {
    return null;
  }
  if (match.__typename !== "AvailableConversationContext") {
    return null;
  }
  let conversationContext = match.context;
  if (conversationContext !== undefined) {
    return JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationViewByConversationContext.make, {
      conversationContext: Primitive_option.some(conversationContext.fragmentRefs),
      activeConversationId: {
        TAG: "Existing",
        _0: props.selectedConversationId
      }
    });
  } else {
    return null;
  }
}

let RecordPageView = {
  ConversationFragment: ConversationFragment,
  make: ConversationPageExistingConversation$RecordPageView
};

function ConversationPageExistingConversation(props) {
  let selectedConversationId = props.selectedConversationId;
  let data = use({
    id: selectedConversationId
  }, undefined, undefined, undefined);
  let match = data.conversationById;
  let tmp;
  if (match !== undefined) {
    switch (match.__typename) {
      case "ConversationV5" :
        tmp = JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(ConversationPageExistingConversation$RecordPageView, {
            conversation: match.fragmentRefs,
            selectedConversationId: selectedConversationId
          }),
          fallback: null
        });
        break;
      case "NotAuthorizedError" :
      case "__unselected" :
        tmp = null;
        break;
    }
  } else {
    tmp = null;
  }
  let match$1 = data.conversationById;
  let tmp$1;
  if (match$1 !== undefined) {
    switch (match$1.__typename) {
      case "ConversationV5" :
        tmp$1 = JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(ConversationPageSelectedConversationDisplayer.make, {
            conversation: match$1.fragmentRefs
          }),
          fallback: JsxRuntime.jsx(Loader.make, {})
        });
        break;
      case "NotAuthorizedError" :
        tmp$1 = "You're not authorized to view this conversation";
        break;
      case "__unselected" :
        tmp$1 = null;
        break;
    }
  } else {
    tmp$1 = "Conversation not found.";
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      tmp,
      tmp$1
    ]
  });
}

let make = ConversationPageExistingConversation;

exports.Query = Query;
exports.RecordPageView = RecordPageView;
exports.make = make;
/* use Not a pure module */
